import { lazyWithRetry } from "./utils/lazyWithRetry";

// User modules (centralized lazy imports)

export const CourseCards = lazyWithRetry(
  () => import("./components/battle-ground/playground/tracks/CourseCards"),
);
export const ModuleCards = lazyWithRetry(
  () => import("./components/battle-ground/playground/tracks/ModuleCards"),
);
export const ScenarioListLab = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/scenario/ScenarioListLab"),
);
export const MainManageLibrary = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/ManageAssets/MainManageLibrary"),
);
export const CreateEvents = lazyWithRetry(
  () => import("./components/events/CreateEvents"),
);
export const EditProfile = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/access-management/EditProfile"),
);
export const Badges = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/achievements/Badges/Badges"),
);
export const Certificate = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/achievements/certificates/Certificate"),
);
export const EditBadge = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/achievements/Edit/EditBadge"),
);
export const EditEventCard = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/achievements/Edit/EditEventCard"),
);
export const EventCard = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/achievements/EventCards/EventCards"),
);
export const CreateQuestionaire = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/CreateQuestionaire"),
);
export const CreateSkill = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-skill-and-category/CreateSkill"),
);
export const ManageAssetsHome = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/ManageAssets/assets/ManageAssetsHome"),
);
export const CreateAssets = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/ManageAssets/assets/CreateAssets"),
);
export const ImageUpload = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/ManageAssets/assets/ImageUpload"),
);
export const ManageFlavorHome = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/ManageAssets/flavor/ManageFlavorHome"),
);

export const TeamsCardsDetails = lazyWithRetry(
  () => import("./components/users/profile/Teams/TeamsCardsDetails"),
);
export const OnboardingModal = lazyWithRetry(
  () => import("./components/battle-ground/playground/OnboardingModal"),
);

export const SoftDeletion = lazyWithRetry(
  () => import("./components/battle-ground/dashboard/SoftDeletion"),
);
export const AdvanceSetting = lazyWithRetry(
  () => import("./components/AdvanceSettings/AdvanceSetting"),
);
export const SupportTicket = lazyWithRetry(
  () => import("./components/ticket-system/SupportTicket"),
);
export const ViewTicket = lazyWithRetry(
  () => import("./components/ticket-system/ViewTicket"),
);
export const ResourcePage = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/Resources/ResourcePage"),
);

export const CreateCourses = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-courses/CreateCourses"),
);
export const CreateTrack = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-tracks/CreateTrack"),
);
export const CreateAchievement = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/CreateAchievement"),
);
export const CreateModule = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/CreateModule"),
);

export const Report = lazyWithRetry(
  () => import("./components/battle-ground/report/Report"),
);

export const CategoryList = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-skill-and-category/CategoryList"),
);
export const CategoryForm = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-skill-and-category/CategoryForm"),
);
export const SkillForm = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-skill-and-category/SkillForm"),
);
export const FullPageOfSkills = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-skill-and-category/FullPageOfSkills"),
);
export const CreateEventExercise = lazyWithRetry(
  () => import("./components/Manage/CreateEventExercise"),
);
export const Teams = lazyWithRetry(
  () => import("./components/Manage/Teams/Teams"),
);
export const CreateTeamsForm = lazyWithRetry(
  () => import("./components/users/profile/Teams/CreateTeamsForm"),
);
export const Organization = lazyWithRetry(
  () => import("./components/Manage/Organization/Organization"),
);

export const CVEAdminReport = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/cve/CVEAdminReport"),
);
export const CVEUserReport = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/cve/CVEUserReport"),
);
export const CreateContent = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/CreateContent"),
);
export const Announcement = lazyWithRetry(
  () => import("./components/Manage/Announcement/Announcement"),
);
export const LeaderBoard = lazyWithRetry(
  () => import("./components/mr-robot-ctf/LeaderBoard"),
);
export const UserActivity = lazyWithRetry(
  () => import("./components/users/profile/activity/UserActivity"),
);
export const UserOrg = lazyWithRetry(
  () => import("./components/users/profile/Organization/UserOrg"),
);
export const UserOverView = lazyWithRetry(
  () => import("./components/users/profile/overview/UserOverView"),
);
export const UserTeams = lazyWithRetry(
  () => import("./components/users/profile/Teams/UserTeams"),
);
export const UserProfileMain = lazyWithRetry(
  () => import("./components/users/profile/UserProfileMain"),
);
export const UserSetting = lazyWithRetry(
  () => import("./components/users/setting/UserSetting"),
);
export const ManageAccess = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/access-management/ManageAccess"),
);
export const AddModulesInCourse = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-courses/AddModulesInCourse"),
);
export const CreateCourseStep1 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-courses/CreateCourseStep1"),
);
export const CreateCourseStep3 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-courses/CreateCourseStep3"),
);
export const AddCourcesInTrack = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-tracks/AddCourcesInTrack"),
);
export const CreateTrackStep1 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-tracks/CreateTrackStep1"),
);
export const CreateTrackstep3 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-tracks/CreateTrackstep3"),
);
export const CreateModuleStep1 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/modules/CreateModuleStep1"),
);
export const CreateModuleStep2 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/modules/CreateModuleStep2"),
);
export const CreateModuleStep3 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/modules/CreateModuleStep3"),
);
export const Event = lazyWithRetry(
  () => import("./components/event-arena/event/Event"),
);
export const EventResources = lazyWithRetry(
  () => import("./components/event-arena/event/EventResources"),
);
export const EventArena = lazyWithRetry(
  () => import("./components/event-arena/EventArena"),
);
export const JoinEvent = lazyWithRetry(
  () => import("./components/event-arena/JoinEvent"),
);
export const EventHomeView = lazyWithRetry(
  () => import("./components/events/PreviewEvents/EventHomeView"),
);
export const UserStatistics = lazyWithRetry(
  () => import("./components/users/profile/statistics/UserStatistics"),
);
export const Exercise = lazyWithRetry(
  () => import("./components/event-arena/event/Exercise"),
);
export const EventLeaderBoard = lazyWithRetry(
  () => import("./components/event-arena/event/EventLeaderBoard"),
);
export const Main = lazyWithRetry(() => import("./components/LegalTnc/Main"));
export const ViewResult = lazyWithRetry(
  () => import("./components/mr-robot-ctf/ViewResult"),
);
export const CvePlay1 = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/cve/CvePlay1"),
);
export const PreviewTracks = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-tracks/PreviewTracks"),
);
export const PreviewCourses = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/create-courses/PreviewCourses"),
);
export const CreateScenario = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/scenario/CreateScenario"),
);
export const Scenario = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/scenario/Scenario"),
);
export const CreateScenarioStep1 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/scenario/CreateScenarioStep1"),
);
export const CreateScenarioStep2 = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/scenario/CreateScenarioStep2"),
);
export const StandaloneModule = lazyWithRetry(
  () =>
    import("./components/battle-ground/playground/assignedExcercises/StandaloneModule"),
);
export const SomethingWentWrong = lazyWithRetry(
  () => import("./pages/SomethingWentWrong"),
);
export const MainDashboard = lazyWithRetry(
  () => import("./components/battle-ground/dashboard/MainDashboard"),
);
export const PageNotFound = lazyWithRetry(() => import("./pages/PageNotFound"));
export const Forbidden = lazyWithRetry(() => import("./pages/Forbidden"));

export const PreviewModule = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/create-content/modules/PreviewModule"),
);
export const Statistics = lazyWithRetry(
  () => import("./components/mr-robot-ctf/Statistics"),
);
export const BrowseScenario = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/scenario/BrowseScenario"),
);
export const BrowseScenarioTemplate = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/scenario/BrowseScenarioTemplate"),
);
export const Stats = lazyWithRetry(
  () => import("./components/mr-robot-ctf/moduleResultStats/Stats"),
);
export const TrackStatistics = lazyWithRetry(
  () => import("./components/battle-ground/playground/tracks/TrackStatistics"),
);
export const TrackStatisticsUser = lazyWithRetry(
  () =>
    import("./components/battle-ground/playground/tracks/TrackStatisticsUser"),
);
export const CourseStatistics = lazyWithRetry(
  () => import("./components/battle-ground/playground/tracks/CourseStatistics"),
);
export const CourseStatisticUser = lazyWithRetry(
  () =>
    import("./components/battle-ground/playground/tracks/CourseStatisticUser"),
);
export const CveLandingPage = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/cve/CveLandingPage"),
);
export const CveList = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/cve/CveList"),
);
export const CveListLab = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/cve/CveListLab"),
);
export const CreateCve = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/cve/CreateCve"),
);
export const PlaySCenariosCVE = lazyWithRetry(
  () =>
    import("./components/battle-ground/playground/playScenariosCVE/PlaySCenariosCVE"),
);
export const CvePages = lazyWithRetry(
  () => import("./components/battle-ground/playground/cve-labs/CvePages"),
);
export const Statistic = lazyWithRetry(
  () => import("./components/event-arena/event/Statistics/Statistic"),
);
export const VerificationPage = lazyWithRetry(
  () => import("./pages/VerificationPage"),
);
export const Expired = lazyWithRetry(() => import("./pages/Expired"));
export const CVEMainPage = lazyWithRetry(
  () => import("./components/battle-ground/cyber-range/play-cve/CVEMainPage"),
);
export const MrRobotCTF = lazyWithRetry(() => import("./pages/MrRobotCTF"));
export const ForgetPassword = lazyWithRetry(
  () => import("./pages/ForgetPassword"),
);
export const SignInPage = lazyWithRetry(() => import("./pages/SignInPage"));
export const SignUpPage = lazyWithRetry(() => import("./pages/SignUpPage"));
export const ResetPassword = lazyWithRetry(
  () => import("./pages/ResetPassword"),
);
export const BattleGround = lazyWithRetry(() => import("./pages/BattleGround"));
export const AccountLockout = lazyWithRetry(
  () => import("./pages/AccountLockout"),
);
export const TracksPage = lazyWithRetry(
  () => import("./components/battle-ground/playground/tracks/TracksPage"),
);
export const CvePage = lazyWithRetry(
  () => import("./components/battle-ground/playground/cve-labs/CvePages"),
);
export const AccessManagement = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/access-management/AccessManagement"),
);
export const PlayGround = lazyWithRetry(
  () => import("./components/battle-ground/playground/PlayGround"),
);
export const HelpPage = lazyWithRetry(
  () => import("./components/mr-robot-ctf/HelpPage"),
);
export const CreateAnn = lazyWithRetry(
  () => import("./components/Manage/Announcement/CreateAnn"),
);
export const PreviewAnn = lazyWithRetry(
  () => import("./components/Manage/Announcement/PreviewAnn"),
);

export const OrganizationPermission = lazyWithRetry(
  () =>
    import("./components/battle-ground/cyber-range/access-management/OrganizationPermission"),
);
